import React from 'react'
import { StyledSectionContainer, ModuleContentContainer, TertiaryTitle } from '../shared/section'
import { colors } from '../../../utils/helpers/colors'
import LinkList from '../shared/LinkList'

const HighlightModule = ({ title, wording, zones }) => (
  <StyledSectionContainer backgroundColor={colors.white} data-testid="section-container-pp">
    <TertiaryTitle data-testid="tertiary-title-pp">{title}</TertiaryTitle>
    <ModuleContentContainer data-testid="module-content-pp">
      <LinkList links={zones} wording={wording} maxLinks={20} />
    </ModuleContentContainer>
  </StyledSectionContainer>
)

export default HighlightModule
